<template>
    <div class="back-box"
         :style="width && `width:${width};`">
        <p class="back" @click.stop="$emit('onSuccess')">
            <span class="iconfont icon-xuanze_xianxing_xiala"></span>返回
        </p>
        <p class="catalog">
            <span class="nav">{{newForm.map(v=>v.name).join('/')}}</span>
        </p>
    </div>
</template>

<script>
    export default {
        name: "back-btn",
        props: {
            width: [String, Number],
            form: Array
        },
        watch: {
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form',vl)},
        },
        data(){
            return {
                newForm: this.form
            }
        }
    }
</script>

<style lang="scss" scoped>
    .back-box{
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0px 20px 20px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: 20px;
        width: 500px;

        .back {
            display: flex;
            cursor: pointer;

            .iconfont {
                font-weight: initial;
                transform: rotate(90deg) scale(0.5);
                font-size: 6px;
                display: inline-block;
            }
        }

        .catalog{
            display: flex;
            flex-direction: row;
            /*flex: 1;*/
            flex-wrap: nowrap;
            margin-left: 16px;
            width: calc(100% - 62px);

            .nav{
                flex-shrink: 0;
                font-size: 14px;
                font-weight: 400;
                color: #909399;
                line-height: 20px;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                display: inline-block;
            }
        }
    }
</style>
